import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useTranslationHook from "../../components/hooks/useTranslationHook";
import { fetchQuantaAPIData } from "../../redux/action/buyerAction";
import { Trans } from "react-i18next";
import { handleNoQuantaData } from "../../redux/slice/buyerSlice";
const AreaComparision = () => {
    const dispatch = useDispatch();
    const { t } = useTranslationHook();
    const lang = useSelector((state) => state.translation.lang);
    const noDataAreaComparison = useSelector((state) => state.buyer.quantaNoData.noDataAreaComparison);
    const [area, setArea] = useState(321);
    const { beds, district, square_footage, district_ar } = useSelector(
        (state) => state.seller.property.propertyData
    );
    useEffect(() => {
        const endpoint = "area-comparison";
        try {
            dispatch(fetchQuantaAPIData(endpoint)).then((response) => {
                // console.log("Area Comparison Response:", response);
                if (Array.isArray(response) && !response.length) {
                    dispatch(handleNoQuantaData({ noDataAreaComparison: true }))
                    return
                }
                const apiArea =
                    // response?.[0]?.projectAvgAreaSqm ||
                    response?.[0]?.districtAvgAreaSqm;
                const comparedPropertyArea =
                    ((square_footage - apiArea) / apiArea) * 100;
                setArea(parseInt(comparedPropertyArea) || 0);
            });
        } catch (error) {
            console.error("One of the requests failed:", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const percentageText =
        area > 0
            ? t("Bigger Percentage", { percentage: Math.abs(area) })
            : t("Smaller Percentage", { percentage: Math.abs(area || 0) });

    const comparisonText =
        beds === 0
            ? t("than the average studio size of a bedroom in")
            : t("than the average size label", { beds });

    return (
        <>
            {noDataAreaComparison ? <></> : <div className="biggerprop">
                <img src="/img/ruler-icon.svg" alt="" />
                {t("")}{" "}
                <Trans
                    i18nKey="property_comparison"
                    values={{
                        percentage: percentageText,
                        comparison: comparisonText,
                        beds,
                        district: lang === "en" ? district : district_ar,
                    }}
                    components={{
                        0: <span />,
                        1: <strong />,
                        2: <span />,
                        3: <span />,
                        4: <span />,
                    }}
                />
            </div>}
        </>
    );
};
export default AreaComparision;
